module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('b', [_vm._v("Memo from the Committee on the First Contact Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("FROM: "), _c('i', [_vm._v("The Committee on the First Contact Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("TO: "), _c('i', [_vm._v("The Members of the First Interstellar Expedition")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("The problem, as we see it, divides in three: (1) You may meet people who have a technology more advanced than ours; (2) You may meet people with an equal technology; (3) You may meet people with a less advanced technology.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("(We will leave aside, for the time being, the problem of what is meant by “more” and “less” advanced. We will also leave aside the possibility that the aliens may have a technology so different from ours that there is no way to compare the two.)")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("We think you are most likely to encounter problem number three: the aliens with a less advanced technology. But we’ll discuss all the possibilities, just in case.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("The aliens with an equal technology present the least problem. We certainly cannot hurt them, not at a distance of 18.2 light-years. If their technology is more or less the same as ours, they won’t be able to hurt us, either. There is the possibility of considerable gain for both cultures without much risk. You can probably go ahead with confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("If you meet aliens with a really advanced technology (with FTL travel, for example) you will have to stop and think.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("According to current social theory, any species that is able to travel to the stars is also able to destroy itself, and any species that can destroy itself, will, unless it learns very quickly how to deal with its own less pleasant aspects.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("We think it’s unlikely that you will meet a star-faring species that is aggressive, violent, bigoted, or crazy with greed. But all our theories are based on a sample of one, and we may not be as nice as we think we are.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("If you meet a species with a superior technology, be cautious. You may want to keep your distance, at least at first. You may not want to tell them where you come from.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("If they are decent and peaceful, they will respect your caution. If they do not, remember that your ship has been provided with the means for self-destruction. If necessary, you can wipe the computer system clean and kill everyone onboard.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("This capability has been provided with extreme reluctance. (See Appendix D.) It may be evidence that we, as a species, have not outgrown our own terrible past.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("The problem when dealing with a more advanced species is self-protection.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("(Remember, when we talk about advancement here, we are speaking only about technology.)")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("The problem when dealing with a less advanced species is karma. We don’t want to hurt them. Our species has done a lot of hurting over time.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Be "), _c('i', [_vm._v("very")]), _vm._v(" careful if you encounter people whose technology is not equal to ours. Remember all the cultures destroyed over the past seven centuries. Remember all the millions of people who have died on Earth: entire tribes and nations, language groups, religions—vanished, murdered. Remember the other hominids who are no longer with us. Remember "), _c('i', [_vm._v("Homo sapiens neanderthalensis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("We think we understand the process now. We think we will not do these things again. But we are not certain.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Go very slowly. Think about what you are doing.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Lao Zi and Zhuang Zi remind us of the dangers of action.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("The masters of Chan and Zen warn us that when we discriminate, when we divide “good” from “evil” and “high” from “low,” we are moving away from true understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Karl Marx tells us that action is inevitable and that we have to discriminate in order to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("You have your choices of sages.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("However, remember that—according to Marx—the goal of socialism is "), _c('i', [_vm._v("mindful")]), _vm._v(" action, history made conscious, people who know what they are doing.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Remember, also, that categories are not fixed. “Good” and “evil” change their meaning. “High” and “low” are relative. The distinctions—the discriminations—you take with you on your journey may not be useful when you arrive.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Good luck.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Copies of this memo have been input to the Open Access Information System (OASIS), the Archives of the Alliance of Human Communities (ANKH), and the Archives of the Fifth, Sixth, and Eighth Internationals.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix A: On the possible meaning(s) of “more” and “less” advanced.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix B: Why we think you are more likely to meet people with a less advanced technology.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix C: Minority report on the dangers of cultural chauvinism.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix D: Minority report on the dangers of fear.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix E: Minority report on the relevance of Daoist and Buddhist concepts.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix F: Minority report on the relevance of Karl Marx.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix G: "), _c('i', [_vm._v("Dao De Jing.")]), _vm._v(" (Complete)")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Appendix H: "), _c('i', [_vm._v("The German Ideology.")]), _vm._v(" (Selections)")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409751ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section5.vue
// module id = 93
// module chunks = 0